<div *ngIf="branding" class="bg-light">
  <referencing-dashboard
    [referees]="referees"
    [userName]="user"
    [companyName]="companyName"
    [role]="role"
    [clientEmail]="clientEmail"
    (refereeToAddDetailsTo)="onAddDetailsPressed($event)"
    *ngIf="!currentReferee">
  </referencing-dashboard>
  <referencing-referee-form
    [referee]="currentReferee"
    [isEditForm]="isEditForm"
    [name]="user"
    [company]="companyName"
    (onSaveRefereeEvent)="closeRefereeForm($event)"
    (onBackButton)="closeForm()"
    class="block"
    *ngIf="currentReferee">
  </referencing-referee-form>
</div>
